<template>
  <div>
    {{ content }}
    <v-img v-if="imageUrl" contain :src="imageUrl" />
  </div>
</template>

<script>
export default {
  props: ['incident'],
  computed: {
    content() {
      return this.content ?? '';
    },
    imageUrl() {
      return this.incident?.imageUrl;
    },
  },
};
</script>
